export const techSupportKey = (module, action = 'list') => `tech_support.${module}.${action}`

export const techSupportAccess = (module, action = 'list') => ({ mode: 'permissions', key: techSupportKey(module, action) })
